import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Explicit FA v6 Regular icon used in FilterTabs
import { faCircleCheck as faCircleCheckRegular } from '@fortawesome/pro-regular-svg-icons/faCircleCheck'
import { faCaretLargeDown } from '@fortawesome/sharp-solid-svg-icons/faCaretLargeDown'
import { faCaretLargeRight } from '@fortawesome/sharp-solid-svg-icons/faCaretLargeRight'

// Add packs
library.add(fas)
library.add(far)

// Add specific icons referenced in code
library.add(faCaretRight, faCaretDown)
library.add(faCircleCheckRegular)
library.add(faCaretLargeDown, faCaretLargeRight)
// Register component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)
